import { render, staticRenderFns } from "./DirectionChart.vue?vue&type=template&id=476cc9f4&"
import script from "./DirectionChart.vue?vue&type=script&lang=js&"
export * from "./DirectionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports